const TRANSLATION_NAMESPACE = "error:slots."

export const GET_SLOT_PAGE_FAILED = `${TRANSLATION_NAMESPACE}fetch-slot-page-failed`
export const CREATE_SLOT_FAILED = `${TRANSLATION_NAMESPACE}create-slot-failed`
export const UPDATE_SLOT_FAILED = `${TRANSLATION_NAMESPACE}update-slot-failed`
export const DELETE_SLOT_FAILED = `${TRANSLATION_NAMESPACE}delete-slot-failed`
